import {PaymentStatusEnum} from '@/services/api-clients';


export function settlementPaymentStatusIconFilter(status: PaymentStatusEnum) {
  switch(status) {
    case PaymentStatusEnum.Waiting: return 'mdi-clock-outline';
    case PaymentStatusEnum.Approved: return 'mdi-check';
    case PaymentStatusEnum.Executed: return 'mdi-send-check';
  }
}
